// extracted by mini-css-extract-plugin
module.exports = {"gridLinesGroup":"GGcCSerJ","yAxisLabel":"CJe1LMjx"};